import { type AuctionSocket, get } from "./auction-socket";
import { type FromWorkerMessage, type ToWorkerMessage } from "./types";

function postMsg(msg: FromWorkerMessage) {
    postMessage(msg);
}

function bindEvents(auctionSocket: AuctionSocket | undefined) {
    if (auctionSocket != null) {
        auctionSocket.onConnectionChange((v) => {
            postMsg({ type: "connectionChange", state: v });
        });
    }
    return auctionSocket;
}

onmessage = async (event) => {
    const data = event.data as ToWorkerMessage;
    switch (data.type) {
        case "appendId": {
            bindEvents(get())!.appendId(...data.args, (id, stampData) => {
                postMsg({ type: "updateId", id, stampData });
            });
            break;
        }
    }
};
